
import { Link } from 'react-router-dom';

export default function Footer() {
  const handleSocialClick = (platform: string) => {
    // In a real app, these would link to actual social media pages
    console.log(`Opening ${platform} page`);
  };

  return (
    <footer className="bg-gray-900 border-t border-gray-800">
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <h3 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              MAVESKY TRAVELS
            </h3>
            <p className="text-gray-400 mb-6 max-w-md">
              Your trusted partner for global flight bookings. We connect travelers worldwide with the best flight deals and exceptional service.
            </p>
            <div className="flex space-x-4">
              <button 
                onClick={() => handleSocialClick('facebook')}
                className="text-gray-400 hover:text-white transition-colors w-8 h-8 flex items-center justify-center cursor-pointer group"
              >
                <i className="ri-facebook-fill text-xl group-hover:scale-110 transition-transform"></i>
              </button>
              <button 
                onClick={() => handleSocialClick('twitter')}
                className="text-gray-400 hover:text-white transition-colors w-8 h-8 flex items-center justify-center cursor-pointer group"
              >
                <i className="ri-twitter-fill text-xl group-hover:scale-110 transition-transform"></i>
              </button>
              <button 
                onClick={() => handleSocialClick('instagram')}
                className="text-gray-400 hover:text-white transition-colors w-8 h-8 flex items-center justify-center cursor-pointer group"
              >
                <i className="ri-instagram-line text-xl group-hover:scale-110 transition-transform"></i>
              </button>
              <button 
                onClick={() => handleSocialClick('linkedin')}
                className="text-gray-400 hover:text-white transition-colors w-8 h-8 flex items-center justify-center cursor-pointer group"
              >
                <i className="ri-linkedin-fill text-xl group-hover:scale-110 transition-transform"></i>
              </button>
              <button 
                onClick={() => handleSocialClick('youtube')}
                className="text-gray-400 hover:text-white transition-colors w-8 h-8 flex items-center justify-center cursor-pointer group"
              >
                <i className="ri-youtube-fill text-xl group-hover:scale-110 transition-transform"></i>
              </button>
            </div>
            
            {/* Social Engagement Stats */}
            <div className="mt-6 grid grid-cols-2 gap-4">
              <div className="bg-gray-800 rounded-lg p-3">
                <p className="text-white font-semibold">12.8K</p>
                <p className="text-gray-400 text-sm">Facebook Followers</p>
              </div>
              <div className="bg-gray-800 rounded-lg p-3">
                <p className="text-white font-semibold">8.4K</p>
                <p className="text-gray-400 text-sm">Instagram Followers</p>
              </div>
            </div>
          </div>
          
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Home</Link></li>
              <li><Link to="/pricing" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Pricing</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Contact</Link></li>
              <li><a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Made with Readdy</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-white font-semibold mb-4">Services</h4>
            <ul className="space-y-2">
              <li><span className="text-gray-400">Flight Booking</span></li>
              <li><span className="text-gray-400">First Class</span></li>
              <li><span className="text-gray-400">Business Class</span></li>
              <li><span className="text-gray-400">Economy Class</span></li>
            </ul>
            
            <div className="mt-6">
              <h4 className="text-white font-semibold mb-3">Follow for Deals</h4>
              <p className="text-gray-400 text-sm mb-3">
                Get exclusive offers and travel tips delivered to your feed!
              </p>
              <div className="flex gap-2">
                <button 
                  onClick={() => handleSocialClick('facebook')}
                  className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
                >
                  Follow
                </button>
                <button 
                  onClick={() => handleSocialClick('instagram')}
                  className="bg-pink-600 hover:bg-pink-700 text-white px-3 py-1 rounded text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
                >
                  Follow
                </button>
              </div>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-center md:text-left">
              &copy; 2024 MAVESKY TRAVELS. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <span className="text-gray-400 text-sm">Connect with us:</span>
              <div className="flex gap-2">
                <button 
                  onClick={() => handleSocialClick('facebook')}
                  className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer"
                >
                  <i className="ri-facebook-fill"></i>
                </button>
                <button 
                  onClick={() => handleSocialClick('twitter')}
                  className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer"
                >
                  <i className="ri-twitter-fill"></i>
                </button>
                <button 
                  onClick={() => handleSocialClick('instagram')}
                  className="text-gray-400 hover:text-pink-400 transition-colors cursor-pointer"
                >
                  <i className="ri-instagram-line"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
